import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../';
import { ErrorHandlerService } from '../../services';
// import {EditorModule,SharedModule} from 'primeng/primeng';
var ViewTopicComponent = /** @class */ (function () {
    function ViewTopicComponent(loginService, route, errorHandlerService, router) {
        this.loginService = loginService;
        this.route = route;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.less = true;
        this.more = false;
        this.query = '';
        this.userId = '';
        this.topicDetail = {};
        this.topicTO = { topicName: '', userDetailsSummaryTO: {}, topicPermissionTO: {} };
        this.commentData = { userDetailsSummaryTO: {} };
        this.innerCommentData = { userReplyingToComment: {} };
        this.topicCmt = [];
        this.user = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.PR = window["PR"];
    }
    ViewTopicComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ViewTopicComponent.prototype.morecontent = function () {
        this.more = true;
        this.less = false;
    };
    ViewTopicComponent.prototype.lesscontent = function () {
        this.more = false;
        this.less = true;
    };
    ViewTopicComponent.prototype.redirectClick = function (url) {
        window.open(url, '_blank');
    };
    ViewTopicComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.topicDetail = { topicTo: { topicName: {} } };
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['topic'] || 0;
            console.log(_this.query);
            if (_this.query != '0') {
                _this.loginService.getTopic(_this.query).subscribe(function (data) {
                    console.log(data);
                    _this.topicDetail = data;
                    _this.topicCmt = data.topicTO.topicComments;
                    _this.topicTO = data.topicTO;
                }, function (error) {
                    _this.handleError(error);
                });
            }
        });
    };
    ViewTopicComponent.prototype.ngAfterViewChecked = function () {
        console.log('ngAfterViewChecked');
        this.PR.prettyPrint();
    };
    ViewTopicComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return ViewTopicComponent;
}());
export { ViewTopicComponent };
//# sourceMappingURL=viewtopic.component.js.map